import { render, staticRenderFns } from "./PageScrollTop.vue?vue&type=template&id=2faefb06"
import script from "./PageScrollTop.vue?vue&type=script&lang=js"
export * from "./PageScrollTop.vue?vue&type=script&lang=js"
import style0 from "./PageScrollTop.vue?vue&type=style&index=0&id=2faefb06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports